const initialState = {
    adminUsers: [],
    adminUser: null,
    isLoading: false,
    isError: false,
    errorMessage: '',
    adminUserUpdated: null,
    adminUserCreated: null,
}

export default function adminReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_ALL_ADMIN_USERS':
            return { ...state, adminUsers: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'GET_ADMIN_USER':
            return { ...state, adminUser: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'UPDATE_ADMIN_USER':
            return { ...state, adminUserUpdated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'CREATE_ADMIN_USER':
            return { ...state, adminUserCreated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'ADMIN_ACTION_STARTS':
            return { 
                ...state, 
                isLoading: true,
                adminUserCreated: null,
                adminUserUpdated: null,
                isError: false,
                errorMessage: ''
            };
        case 'ADMIN_ACTION_ERRORS':
            return { ...state, isError: true, errorMessage: action.payload, isLoading: false };
        case 'RESET_ADMIN_ERRORS':
            return { 
                ...state, 
                isError: false, 
                errorMessage: '',
            };
        default:
            return state;
    }
}